import { render, staticRenderFns } from "./description.vue?vue&type=template&id=6b7e97ba&"
import script from "./description.vue?vue&type=script&lang=js&"
export * from "./description.vue?vue&type=script&lang=js&"
import style0 from "./description.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/deploy/iot-product-tool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7e97ba')) {
      api.createRecord('6b7e97ba', component.options)
    } else {
      api.reload('6b7e97ba', component.options)
    }
    module.hot.accept("./description.vue?vue&type=template&id=6b7e97ba&", function () {
      api.rerender('6b7e97ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/factory/description.vue"
export default component.exports